var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCozmosIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04 21.55h15.878c-1.995 2.1-4.792 3.429-7.92 3.429-3.135 0-5.96-1.318-7.959-3.43zM14 3.02c3.137 0 5.963 1.318 7.958 3.43H6.079C8.074 4.346 10.87 3.02 14 3.02zM14 0C7.856 0 2.65 3.965.765 9.468h23.222c.428.944.731 1.956.879 3.021H.085C.031 12.986 0 13.49 0 14c0 7.731 6.269 14 14 14 6.144 0 11.35-3.965 13.235-9.468H4.015a10.93 10.93 0 0 1-.878-3.021h24.778c.054-.496.085-1 .085-1.511 0-7.731-6.269-14-14-14z",
    fill: "url(#9x576omvya)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "9x576omvya",
    x1: 0,
    y1: 14,
    x2: 28,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#4441DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#5242D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#7744B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#B2478E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ED4A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7340"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCozmosIcon);
export default __webpack_public_path__ + "static/media/cozmos-icon.fee72a7c075ec5bdc4ae60d097d80821.svg";
export { ForwardRef as ReactComponent };